export default "__VITE_ASSET__DPlqVR1A__"